"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomerSelectionFormContent = void 0;
var _components = require("@ori-ui/components");
var _reactHookForm = require("react-hook-form");
var _api = require("../../../api");
var _components2 = require("../../../components");
var _types = require("../../../types");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable react/jsx-no-bind -- x */

const CustomerSelectionFormContent = () => {
  const {
    control,
    formState,
    handleSubmit,
    setValue
  } = (0, _reactHookForm.useFormContext)();
  const {
    field: customerTypeField
  } = (0, _reactHookForm.useController)({
    name: 'customerType',
    control
  });
  const {
    postSubscription
  } = (0, _api.usePostSubscription)();
  const handleChange = ({
    currentTarget: {
      value
    }
  }) => {
    setValue('customerType', value);
    if (value === _types.ECustomerTypeSelection.Myself) {
      setValue('existingCustomerId', null);
      setValue('customerFirstName', '');
      setValue('customerSurname', '');
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components2.MyselfSection, {
      selected: customerTypeField.value === _types.ECustomerTypeSelection.Myself,
      value: _types.ECustomerTypeSelection.Myself,
      onChange: e => {
        customerTypeField.onChange(e);
        handleChange(e);
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components2.OtherCustomersSection, {
      selected: customerTypeField.value === _types.ECustomerTypeSelection.ExistingCustomer,
      value: _types.ECustomerTypeSelection.ExistingCustomer,
      onChange: e => {
        customerTypeField.onChange(e);
        handleChange(e);
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
      fullWidth: true,
      color: "primary",
      variant: "contained",
      disabled: !formState.isValid || formState.isSubmitting,
      sx: {
        marginTop: 2
      },
      onClick: handleSubmit(postSubscription),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components2.FormattedMessage, {
        id: "save"
      })
    })]
  });
};
exports.CustomerSelectionFormContent = CustomerSelectionFormContent;
